(function () {

  'use strict';

  function pxCloudStorageDirective(
    $timeout, $filter, toastr, $rootScope, CloudStorageService, EventServiceEvents, $ngBootbox, CopilotService
  ) {
    return {
      restrict: 'EA',
      scope: {
        tenant: '=tenant',
        me: '=me',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/settings/cloudStorage/cloudStorage.template.html',
      link: function(scope, element) {

        scope.loading = true;
        scope.deleteInProgress = false;
        scope.nestedContext = null;
        scope.cloudStorageList = [];

        (function () {
          getCloudStoragesOfTenant();
          fulfillCopilotRequest();
        })();

        function getCloudStoragesOfTenant() {
          scope.loading = true;
          CloudStorageService.getCloudStorages().then(function (cloudStorages) {
            cloudStorages = improveListData(cloudStorages);
            scope.cloudStorageList = cloudStorages;
            scope.loading = false;
            setFirstLastIndicator();
            resetCloudStorageErrors();
            checkForCloudStorageErrors();
          }).catch(function (response) {
            scope.loading = false;
            if (response.status !== 404) {
              console.error('Failed to retrieve cloud storages.');
            }
          });
        }
        function fulfillCopilotRequest() {
          const copilotActionButton = element.find('[copilot-action]')[0];
          if (!copilotActionButton) { return; }
          const copilotAction = copilotActionButton.getAttribute('copilot-action');
          if (!copilotAction || CopilotService.state.requestedAction.responseType !== copilotAction) {
            return;
          }
          $timeout(function () {
            const copilotParameters = CopilotService.useCloudStorageParameters();
            const elementRect = copilotActionButton.getBoundingClientRect();
            scope.openContextMenu({ clientX: elementRect.x, clientY: elementRect.y + elementRect.width },
              copilotParameters.name || copilotParameters.provider
                ? {
                  info: {
                    name: copilotParameters.name || '',
                    type: copilotParameters.provider == 'GOOGLE' ? 'GOOGLE_CLOUD_STORAGE' : 'AZURE_BLOB_STORAGE'
                  }
                }
                : null,
              {
                title: 'AddCloudStorage', type: 'addCloudStorage', name: 'AddCloudStorage', bypassCloseOutside: true, primaryAction: 'CREATE'
              });
          }, 100);
        }


        function improveListData(cloudStorages) {
          cloudStorages.forEach((cloudStorage) => {
            cloudStorage.DOM_VIEW_DATA = {
              canBeUsedForPrint:
                cloudStorage.info.docSources.includes('PRINT_ANYWHERE') ||
                cloudStorage.info.docSources.includes('PRINT_LATER') ||
                cloudStorage.info.docSources.includes('VIA_THE_CLOUD') ||
                cloudStorage.info.docSources.includes('CHROME_PRINT') ||
                cloudStorage.info.docSources.includes('MOBILE_PRINT'),
              canBeUsedForCapture:
                cloudStorage.info.docSources.includes('PRINT_CAPTURE') ||
                cloudStorage.info.docSources.includes('MOBILE_CAPTURE')
            };
          });
          return cloudStorages;
        }

        function resetCloudStorageErrors() {
          angular.forEach(scope.cloudStorageList, function (cloudstorage) {
            delete cloudstorage.hasError;
          });
        }

        function checkForCloudStorageErrors() {
          angular.forEach(scope.tenant.info._embedded.openIssues, function (issue) {
            if (issue.type === 'CLOUD_STORAGE_BROKEN') {
              scope.cloudStorageList.find(cloudStorage => {
                if (issue._links['px:cloudStoreAccount'].href === cloudStorage.info._links.self.href) {
                  cloudStorage.hasError = issue;
                }
              });
            }
          });
        }

        scope.testCloudStorage = function (cloudStorage) {
          scope.selectedContextMenuItem = {
            title: 'Test',
            type: 'testCloudStorage',
            bypassCloseOutside: false
          };
          scope.context = cloudStorage;
          scope.resource = scope.tenant;
        };

        function deleteCloudStorage(cloudStorage) {
          $ngBootbox.confirm($filter('stringular')($filter('translate')('DeleteCloudStorage'), cloudStorage.info.name)).then(function () {
            cloudStorage.deleteCloudStorage(cloudStorage).then(function (response) {
              toastr.success($filter('translate')('Deleted'));
            }).catch(function (error) {
              toastr.error($filter('translate')('ERROR'));
            });
          }).catch(function(error) {});
        }

        function changeCloudStorageState(cloudStorage) {
          const modifiedCloudStorage = angular.copy(cloudStorage);
          modifiedCloudStorage.info.active = !modifiedCloudStorage.info.active;
          cloudStorage.saveChanges(modifiedCloudStorage).then(function () {
            toastr.success($filter('translate')('ChangesSaved'));
            getCloudStoragesOfTenant();
          }).catch(function(err) {
            toastr.error($filter('translate')('ERROR'));
          });
        }

        scope.openContextMenu = function (event, context, menuOption) {
          $timeout(function () {
            if (event, context, menuOption) {
              scope.selectedContextMenuItem = menuOption;
              scope.contextPosition = { left: event.clientX + 100, top: event.clientY + 100 };
              scope.context = context;
              scope.resource = scope.tenant;
              scope.auxiliaries = {
                me: scope.me
              };
            }
          }, 50);
        };

        scope.closeAllMenus = function () {
          scope.selectedContextMenuItem = null;
          scope.contextPosition = null;
          scope.context = null;
          scope.resource = null;
        };

        function modifyCloudStorage(cloudStorage, primaryAction, secondaryAction) {
          scope.closeAllMenus();
          scope.selectedContextMenuItem = {
            title: 'ModifyCloudStorage',
            type: 'addCloudStorage',
            bypassCloseOutside: true,
            primaryAction: primaryAction,
            secondaryAction: secondaryAction
          };
          scope.context = cloudStorage;
          scope.resource = scope.tenant;
          scope.auxiliaries = {
            me: scope.me
          };
        }

        function moveCloudStorageUp(cloudStorage) {
          const index = scope.cloudStorageList.indexOf(cloudStorage);
          if (index > 0) {
            scope.cloudStorageList.splice(index, 1);
            scope.cloudStorageList.splice(index - 1, 0, cloudStorage);
            saveOrderOfCloudStorages();
          }
        }

        function moveCloudStorageDown(cloudStorage) {
          const index = scope.cloudStorageList.indexOf(cloudStorage);
          if (index < scope.cloudStorageList.length - 1) {
            scope.cloudStorageList.splice(index, 1);
            scope.cloudStorageList.splice(index + 1, 0, cloudStorage);
            saveOrderOfCloudStorages();
          }
        }

        function saveOrderOfCloudStorages() {
          const order = scope.cloudStorageList.map(cloudStorage => cloudStorage.customProperties.id);
          CloudStorageService.setOrderOfCloudStorages(order).then(function (response) {
            setFirstLastIndicator();
          }).catch(function (err) {
            toastr.error($filter('translate')('FailedChangeOrderCloudStorages'));
            getCloudStoragesOfTenant();
          });
        }

        function setFirstLastIndicator() {
          if (scope.cloudStorageList.length) {
            const first = scope.cloudStorageList[0];
            const last = scope.cloudStorageList[scope.cloudStorageList.length - 1];
            scope.cloudStorageList.forEach(cloudStorage => {
              cloudStorage.options.first = cloudStorage === first;
              cloudStorage.options.last = cloudStorage === last;
            });
          }
        }

        scope.openListMenu = function (event, cloudStorage) {
          scope.closeAllMenus();
          $timeout(function () {
            scope.closeListMenu();
            scope.listMenuContext = cloudStorage;
            scope.listMeta = {
              offset: { horizontal: -20, vertical: -120 },
              parentId: event.target.id,
              type: 'cloudStorageList',
              scrollContainerId: 'CLOUD_STORAGE_LIST_SCROLL_CONTAINER'
            };
          });
        };

        scope.closeListMenu = function (cloudStorage, action) {
          scope.listMenuContext = null;
          scope.listMeta = null;
          switch (action) {
            case 'CONFIGURATION':
              modifyCloudStorage(cloudStorage, 'MODIFY');
              break;
            case 'ACTIVATE':
            case 'DEACTIVATE':
              changeCloudStorageState(cloudStorage);
              break;
            case 'TEST':
              scope.testCloudStorage(cloudStorage);
              break;
            case 'DELETE_CLOUDSTORAGE':
              deleteCloudStorage(cloudStorage);
              break;
            case 'MOVE_UP':
              moveCloudStorageUp(cloudStorage);
              break;
            case 'MOVE_DOWN':
              moveCloudStorageDown(cloudStorage);
              break;
            }
        };

        ////////////////////////////////////////////
        // TOOLTIP STUFF
        ////////////////////////////////////////////

        scope.showTooltip = function (showTip, position, type, context) {
          if (showTip) {
            tooltip(position, type, context);
          } else {
            clearTooltip();
          }
        };

        function tooltip(position, type, context) {
          clearTooltip();
          scope.tooltipContent = {
            title: type.charAt(0).toUpperCase() + type.slice(1),
            type: type,
            context: context
          };
          scope.tooltipObject = {
            position: { left: position.startX, top: position.startY + 20 }
          };
        }

        function clearTooltip() {
          scope.tooltipContent = null;
          scope.tooltipObject = null;
        }

        ////////////////////////////////////////////
        // EVENT LISTENERS
        ////////////////////////////////////////////

        var TENANT_CLOUD_STORE_ACCOUNT_CREATED_listener = $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.TENANT_CLOUD_STORE_ACCOUNT_CREATED, function () {
          getCloudStoragesOfTenant();
        });

        var TENANT_CLOUD_STORE_ACCOUNT_UPDATED_listener = $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.TENANT_CLOUD_STORE_ACCOUNT_UPDATED, function () {
          getCloudStoragesOfTenant();
        });

        var TENANT_CLOUD_STORE_ACCOUNT_DELETED_listener = $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.TENANT_CLOUD_STORE_ACCOUNT_DELETED, function () {
          getCloudStoragesOfTenant();
        });

        var TEST_CLOUD_STORAGE_listener = $rootScope.$on('TEST_CLOUD_STORAGE', function (channelRef, data) {
          scope.testCloudStorage(data.cloudstorage);
        });

        var MODIFY_CLOUD_STORAGE_NAME_listener = $rootScope.$on('MODIFY_CLOUD_STORAGE_NAME', function (channelRef, data) {
          modifyCloudStorage(data.cloudstorage, 'TROUBLESHOOT', 'MODIFY_NAME');
        });

        var MODIFY_CLOUD_STORAGE_KEY_listener = $rootScope.$on('MODIFY_CLOUD_STORAGE_KEY', function (channelRef, data) {
          modifyCloudStorage(data.cloudstorage, 'TROUBLESHOOT', 'MODIFY_KEY');
        });

        var MODIFY_S3_DETAILS_listener = $rootScope.$on('MODIFY_S3_DETAILS', function (channelRef, data) {
          modifyCloudStorage(data.cloudstorage, 'TROUBLESHOOT', 'MODIFY_DETAILS');
        });

        scope.$on('$destroy', function () {
          TENANT_CLOUD_STORE_ACCOUNT_CREATED_listener();
          TENANT_CLOUD_STORE_ACCOUNT_UPDATED_listener();
          TENANT_CLOUD_STORE_ACCOUNT_DELETED_listener();
          TEST_CLOUD_STORAGE_listener();
          MODIFY_CLOUD_STORAGE_NAME_listener();
          MODIFY_CLOUD_STORAGE_KEY_listener();
          MODIFY_S3_DETAILS_listener();
        });

      }
    };
  }

  pxCloudStorageDirective.$inject = [
    '$timeout', '$filter', 'toastr', '$rootScope', 'CloudStorageService', 'EventServiceEvents', '$ngBootbox', 'CopilotService'
  ];

  angular
    .module('printix-admin')
    .directive('pxCloudStorageDirective', pxCloudStorageDirective);

})();
